module.exports = __webpack_public_path__ + "img/In-ve.171ab650.png";